import {DrupalMedia} from "next-drupal";
import {FormattedText} from "../formatted-text";
import {MediaImage} from "../templates/media/media--image";
import {ARTICLE_TEASER_IMAGE_STYLE} from "../../types/image-styles";


export function WidgetCategoryBox ({image, title, description, buttons, ...props}: {
    image?: DrupalMedia,
    title: string,
    description?: string,
    buttons?: Array<{
      uri: string,
      url: string,
      title: string,
    }>,
  }) {
    return (
        <div className="flex flex-col text-black z-10 justify-start flex-grow">
            <div className="grid flex-grow">
                <div className="grid">
                    {image && (
                    <MediaImage
                        media={image}
                        imageStyle={ARTICLE_TEASER_IMAGE_STYLE}
                        childClass="rounded-t-md md:max-h-60 lg:max-h-72 w-full object-cover h-[32vh]"
                    />
                    )}
                    <h2 className="font-bold text-primary text-2xl pt-6 pb-0 px-4 md:px-10 leading-tight">{title}</h2>
                    <div className="px-4 md:px-10 pt-4 font-normal text-black [&>p]:text-base">
                        {description && <FormattedText processed={description} />}
                    </div>
                </div>
                <div className="grid flex-grow px-4 md:px-10 pt-6 pb-6 items-start">
                    <div className="grid cursor-pointer self-end">
                        {buttons && buttons.map((button, index) => button.uri ? (
                            <a key={index} href={button?.url ?? ""} className="py-2 px-3 border-2 font-bold rounded-sm flex-row items-center justify-center transition-all duration-500 border-primary bg-primary text-white hover:border-2 hover:border-primary hover:text-primary hover:bg-white flex mb-2">
                                {button.title || 'Learn More'} 
                            </a>
                        ) : null
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
  }
